// 首先获取视频最外层 dom 元素
var parentElement = document.querySelector('.html5-video-player')

// 给最外层父盒子添加样式
try {
  parentElement.style.position = 'fixed'
  parentElement.style.top = '0'
  parentElement.style.left = '0'
  parentElement.style.zIndex = 1000000
} catch (error) {
  console.log(error)
}

// 获取视频标签
var playerElement = document.querySelector('video')

// 给视频添加样式
try {
  playerElement.style.width = '1920px'
  playerElement.style.height = '911px'
  playerElement.style.position = 'fixed'
  playerElement.style.top = 0
  playerElement.style.left = 0
  playerElement.style.background = '#000'
} catch (error) {
  console.log(error)
}

// 获取 youtube 自定义的 video control 元素
var controlElement = document.querySelector('.ytp-chrome-bottom')
var sliderElement = document.querySelector('.ytp-chapter-hover-container')

// 给视频控制栏添加样式
try {
  controlElement.style.width = '98%'
  sliderElement.style.width = '100%'
} catch (error) {
  console.log(error)
}






// var reTryNumber = 0
// var timeoutTimer = 

function setVideoConfig () {
  var contentElement = document.querySelector('#content')
  try {
    contentElement.style.height = '98vh'
    contentElement.style.overflow = 'hidden'
  } catch (error) {
    console.log(error)
  }
  var parentElement = document.querySelector('.html5-video-player')
  try {
    parentElement.style.position = 'fixed'
    parentElement.style.zIndex = 1000000
    parentElement.style.top = '0px'
    parentElement.style.left = '0px'
  } catch (error) {
    console.log(error)
  }
  var playerElement = document.querySelector('video')
  try {
    playerElement.style.width = '1920px'
    playerElement.style.height = '1080px'
    playerElement.style.position = 'fixed'
    playerElement.style.top = '0px'
    playerElement.style.left = '0px'
    playerElement.style.objectFit = 'contain'
    playerElement.style.background = '#000'
  } catch (error) {
    console.log(error)
  }
  var controlElement = document.querySelector('.ytp-chrome-bottom')
  var sliderElement = document.querySelector('.ytp-chapter-hover-container')
  var listElement = document.querySelector('#secondary')
  var msgElement = document.querySelector('#below')
  var htmlElement = document.querySelector('html')
  try {
    controlElement.style.width = '98%'
    sliderElement.style.width = '100%'
    listElement.style.display = 'none'
    msgElement.style.display = 'none'
    htmlElement.style.height = '100vh'
    htmlElement.style.overflow = 'hidden'
  } catch (error) {
    console.log(error)
  }
}
setVideoConfig()
var observer1 = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'childList' || mutation.type === 'attributes' || mutation.type === 'characterData') {
      setVideoConfig()
    }
  })
})
var config = { attributes: true, childList: true, characterData: true, subtree: true }
var targetNode =  document.querySelector('.html5-video-player')
if (targetNode) {
  observer1.observe(targetNode, config)
}


